import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'
import users from './users'
import payments from './payments'
// import cases from './cases'
import settings from './settings'
import apitokens from './apitokens'
import apisettings from './apisettings'
import adminsetting from './adminsetting'
import invoicing from './invoicing'
// import invoices from './invoices'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/debtoragreementplans/:token',
      name: 'debtorsagreementplans',
      component: () => import('@/views/Debtorsagreementplans.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/invoices/payment/:token',
      name: 'invoices-payment',
      component: () => import('@/views/InvoicePaymentPlan.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/paylike/',
      name: 'paylike',
      component: () => import('@/views/Paylike.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/dibs/',
      name: 'dibs',
      component: () => import('@/views/Dibs.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'DEBTIA_HOME',
        breadcrumb: [
          {
            text: 'DEBTIA_HOME',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
        resource: 'MyRule',
        action: 'rule',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        resource: 'Auth',
        action: 'read',
      },
    },
    ...users,
    ...payments,
    // ...invoices,
    // ...cases,
    ...settings,
    ...apitokens,
    ...apisettings,
    ...adminsetting,
    ...invoicing,
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  // Redirect if logged in

  return next()
})

export default router
